import { useState, useEffect } from 'react'
import {
  initialSingleReview,
  initialerror,
  initialpersonValue,
  initialvalueForeditBoolean,
} from '../../Data/StaticPersonandMoviedata'
import Validation from '../CreatePersonValidation'
import GetPerson from '../../../Services/Queries/GetPerson'
import PersonDataforForm from '../PersonDataforForm'

const usePersonData = () => {
  const [PersoninputData, setInputData] = useState(initialpersonValue)
  const [personName, setPersonName] = useState('')
  const [personNamete, setPersonNamete] = useState('')
  const [valueChanged, setValueChanged] = useState(initialvalueForeditBoolean)
  const [shortBio, setShortBio] = useState('')
  const [shortBiote, setShortBiote] = useState('')
  const [wikipediaURL, setWikipediaURL] = useState('')
  const [error, setError] = useState(initialerror)
  const [personData, setPersonData] = useState({})
  const [personalAndBackGroundInfo, setPersonalAndBackGroundInfo] = useState([])
  const [personFavorites, setPersonFavorites] = useState([])
  const [personDataCareers, setPersonDataCareers] = useState([])
  const [personalAssetsAndSocialMedia, setPersonalAssetsAndSocialMedia] = useState([])
  const [rumorsAndControversies, setRumorsAndControversies] = useState([])
  const [businessVentures, setBusinessVentures] = useState([])
  const [politicsInfo, setPoliticsInfo] = useState([])
  const [familyAndRelationships, setFamilyAndRelationships] = useState([])
  const [achievementsAndHonors, setAchievementsAndHonors] = useState([])
  const [loader, setLoader] = useState(false)
  const [mode, setMode] = useState('edit')
  const [reviews, setReviews] = useState([])

  const updateMultipleInputData = input => {
    setInputData(prevData => ({ ...prevData, ...input }))
  }

  const sendValueChangedBoolean = (field, data) => {
    setValueChanged(prevValueChanged => ({
      ...prevValueChanged,
      [field]: data,
    }))
  }

  const fetchPersonData = async () => {
    setLoader(true)
    const url = window.location.href
    const urlSplit = url.split('?')
    setValueChanged(initialvalueForeditBoolean)

    if (urlSplit[1]) {
      const data = await GetPerson({ PK: decodeURIComponent(urlSplit[1]) })

      const inputData = await PersonDataforForm(data || {})
      updateMultipleInputData(inputData)
      setPersonData(data)
      setPersonDataCareers(data?.career || [])
      setPersonFavorites(data?.favourites || [])
      setPersonNamete(data?.name_Te || '')
      setPersonName(data?.name_En || '')
      setShortBio(data?.about_En || '')
      setShortBiote(data?.about_Te || '')
      setPersonalAndBackGroundInfo(data?.personalAndBackgroundInfo || {})
      setPersonalAssetsAndSocialMedia(data?.personalAssetsAndSocialMedia || [])
      setRumorsAndControversies(data?.rumorsAndControversies || [])
      setFamilyAndRelationships(data?.familyAndRelationships || [])
      setBusinessVentures(data?.businessVentures || [])
      setPoliticsInfo(data?.politicsInfo || [])
      setWikipediaURL(data?.personWikiURL || '')
      setAchievementsAndHonors(data?.achievementsAndHonors || [])
      setReviews(data?.yousayArticleReviews || [initialSingleReview])
      setMode('edit')
    } else if (url.includes('createperson')) {
      setMode('create')
    } else {
      setMode('edit')
    }

    setLoader(false)
  }

  useEffect(() => {
    fetchPersonData()
  }, [])

  useEffect(() => {
    const validationInput = {
      personName,
      personNamete,
      shortBio,
      shortBiote,
      wikipediaURL,
    }
    const errorArray = Validation(validationInput)
    setError(errorArray)
  }, [personName, personNamete, shortBiote, shortBio, wikipediaURL])

  return {
    loader,
    PersoninputData,
    personName,
    personNamete,
    shortBio,
    shortBiote,
    wikipediaURL,
    error,
    personData,
    personalAndBackGroundInfo,
    personFavorites,
    personDataCareers,
    personalAssetsAndSocialMedia,
    rumorsAndControversies,
    businessVentures,
    politicsInfo,
    familyAndRelationships,
    valueChanged,
    achievementsAndHonors,
    mode,
    reviews,
    setPoliticsInfo,
    setPersonName,
    setPersonNamete,
    setShortBio,
    setShortBiote,
    setWikipediaURL,
    setPersonFavorites,
    setPersonDataCareers,
    setPersonalAssetsAndSocialMedia,
    setRumorsAndControversies,
    setBusinessVentures,
    setInputData,
    setFamilyAndRelationships,
    setPersonalAndBackGroundInfo,
    updateMultipleInputData,
    sendValueChangedBoolean,
    fetchPersonData,
    setAchievementsAndHonors,
    setLoader,
    setReviews,
  }
}

export default usePersonData
